export const SOURCES = [
  { id: "google_ads", label: "Google Ads", short: "GADS" },
  { id: "meta_lead_form", label: "Meta Lead Form", short: "META" },
  { id: "referrals", label: "Referrals", short: "REF" },
  { id: "whatsapp_enquiry", label: "WhatsApp Enquiry", short: "WA" },
  { id: "confirmed_appointment", label: "Confirmed Appointment", short: "APPT" },
  { id: "direct_walkin", label: "Direct Walk-in", short: "WALK" },
  { id: "338_number", label: "338 Number", short: "338" },
  { id: "400_number", label: "400 Number", short: "400" },
  { id: "2020_number", label: "2020 Number", short: "2020" },
  { id: "ht_form", label: "HT Form", short: "HT" },
  { id: "hair_treatment_form", label: "Hair Treatment Form", short: "HTF" },
  { id: "hyd_form", label: "Hyd Form", short: "HYD" },
  { id: "callyzer", label: "Callyzer", short: "CALL" },
  { id: "kraya_whatsapp", label: "Kraya WhatsApp", short: "KRAYA" },
];

export const STATUSES = [
  { id: "new", label: "New", color: "#002FA7" },
  { id: "contacted", label: "Contacted", color: "#52525B" },
  { id: "rnr_1", label: "RNR 1", color: "#F5A623" },
  { id: "rnr_2", label: "RNR 2", color: "#E58E0B" },
  { id: "rnr_3", label: "RNR 3", color: "#C2710C" },
  { id: "appointment_booked", label: "Appointment Booked", color: "#002FA7" },
  { id: "switch_off", label: "Switch Off", color: "#71717A" },
  { id: "out_of_location", label: "Out of Location", color: "#71717A" },
  { id: "call_disconnected", label: "Call Disconnected", color: "#71717A" },
  { id: "busy", label: "Busy", color: "#71717A" },
  { id: "not_interested", label: "Not Interested", color: "#E00000" },
  { id: "call_back", label: "Call Back", color: "#F5A623" },
  { id: "follow_back", label: "Follow Back", color: "#F5A623" },
  { id: "qualified", label: "Qualified", color: "#8A2BE2" },
  { id: "converted", label: "Converted", color: "#008A00" },
  { id: "visited", label: "Visited", color: "#5C26B5" },
  { id: "booked", label: "Booked", color: "#006B00" },
  { id: "existing_client", label: "Existing Client", color: "#0E7490" },
  { id: "lost", label: "Lost", color: "#E00000" },
];

export const labelFor = (list, id) => list.find((x) => x.id === id)?.label || id;
export const colorFor = (id) => STATUSES.find((s) => s.id === id)?.color || "#52525B";
